"use client"

import { type IPaymentQueryParams } from "@/lib/centra-client/interfaces/IPaymentService"
import logger from "@/lib/logger/logger-init"
import { type CheckoutAPISelectionWithRequiredToken } from "@/types/centra/checkout-api/selection/get-selection"
import { type Result, ResultFactory } from "@/types/generic/Result"

export const paymentFields = async (
    params: IPaymentQueryParams & { vouchers?: any[] }
): Promise<Result<CheckoutAPISelectionWithRequiredToken>> => {
    try {
        const response = await fetch("/api/centra/payment-fields", {
            method: "PUT",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(params)
        })

        const result = await response.json()

        if (!response.ok || !result.success) {
            const errorMessage = result.error || "Failed to change payment fields"
            logger.error(errorMessage)
            return ResultFactory.failure<CheckoutAPISelectionWithRequiredToken>(
                new Error(errorMessage)
            )
        }

        return ResultFactory.success<CheckoutAPISelectionWithRequiredToken>(result.data)
    } catch (error) {
        logger.error("Unexpected error in PaymentFields", error)
        return ResultFactory.failure<CheckoutAPISelectionWithRequiredToken>(
            error instanceof Error ? error : new Error("An unknown error occurred")
        )
    }
}
